import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.99625 19.9201L15.5162 13.4001C16.2863 12.6301 16.2863 11.3701 15.5162 10.6001L8.99625 4.08008",
		stroke: "#787878",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowLeftIcon;
